import { IApiError } from '@/models/apiError.model';
import { ICategory, ICategoryDetails, ICategoryStats, IGetCategoryStatsDTO } from '@/models/categories.model';
import { IFilter, IFilterValue } from '@/models/filters.model';
import { IPagination } from '@/models/pagination.model';
import { TGetFiltersQuery, TGetFiltersValuesQuery } from '../helpers/types';

export const CATEGORIES_SLICE_NAME = 'categories';

export interface CategoriesState {
  categories: ICategory[] | null;
  popularCategories: ICategory[] | null;
  categoriesAutocomplete: ICategory[] | null;
  categoryDetails: ICategoryDetails | null;
  filterDetails: IFilter | null;
  categoryStats: ICategoryStats | null;
  categoryStatsQuery: IGetCategoryStatsDTO;
  filters: {
    data: IFilter[];
    meta: IPagination;
  } | null;
  filtersList: {
    data: IFilter[];
    meta: IPagination;
  } | null;
  filterValues: {
    data: IFilterValue[];
    meta: IPagination;
  } | null;
  filtersQuery: TGetFiltersQuery | null;
  filtersValuesQuery: TGetFiltersValuesQuery | null;
  isLoadingCategories: boolean;
  isLoadingCategoryDetails: boolean;
  isLoadingFilterDetails: boolean;
  isLoadingFilters: boolean;
  isLoadingFiltersList: boolean;
  isLoadingCategoryFiltersList: boolean;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: CategoriesState = {
  categories: null,
  categoriesAutocomplete: null,
  popularCategories: null,
  categoryDetails: null,
  filterDetails: null,
  categoryStats: null,
  categoryStatsQuery: {},
  filters: null,
  filtersList: null,
  filterValues: null,
  filtersValuesQuery: null,
  filtersQuery: null,
  isLoadingCategories: false,
  isLoadingCategoryDetails: false,
  isLoadingFilterDetails: false,
  isLoadingFilters: false,
  isLoadingFiltersList: false,
  isLoadingCategoryFiltersList: false,
  isLoading: false,
  error: null,
};
